/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `MagicToken.ts` file.
 ******/
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

import { MagicToken } from "./MagicToken";

import { User } from "./User";

export abstract class MagicTokenModel {
    id: number;
    createdAt: Dayjs;
    expiresAt: Dayjs;
    magicToken: string;
    magicTokenHash: string | null;
    returnUrl: string | null;
    updatedAt: Dayjs;
    userId: number | null;
    user: User | null | undefined;
    _destroy: boolean | undefined;

    constructor(
        id: number,
        createdAt: Dayjs,
        expiresAt: Dayjs,
        magicToken: string,
        magicTokenHash: string | null,
        returnUrl: string | null,
        updatedAt: Dayjs,
        userId: number | null,
        user: User | null | undefined
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.expiresAt = expiresAt;
        this.magicToken = magicToken;
        this.magicTokenHash = magicTokenHash;
        this.returnUrl = returnUrl;
        this.updatedAt = updatedAt;
        this.userId = userId;
        this.user = user;
    }

    static fromApiObject(json: any, timezone: string): MagicToken {
        const newObject = new MagicToken(
            json["id"],
            dayjs(json["created_at"]).tz(timezone),
            dayjs(json["expires_at"]).tz(timezone),
            json["magic_token"],
            json["magic_token_hash"],
            json["return_url"],
            dayjs(json["updated_at"]).tz(timezone),
            json["user_id"],
            json["user"] == null ? json["user"] : User.fromApiObject(json["user"], timezone)
        );

        return newObject;
    }

    toApiObject(): any {
        return {
            id: this.id,
            created_at: this.createdAt,
            expires_at: this.expiresAt,
            magic_token: this.magicToken,
            magic_token_hash: this.magicTokenHash,
            return_url: this.returnUrl,
            updated_at: this.updatedAt,
            user_id: this.userId,
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): MagicToken {
        const clone = Object.create(this) as MagicToken;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
